module.exports = "<div class=\"nav nav-tabs tabs-heavy mb-m pl-s d-none d-flex\" name=\"tabset\" id=\"tabset\" role=\"tablist\">\n  <% index = 0 %>\n  <% navTabsLabel.forEach(function(navTabLabel) { %>\n  <a data-tab-label=\"navTab<%= index %>\" class=\"nav-item nav-link tab-item mr-xs active\" data-toggle=\"tab\" href=\"#navTab<%= index %>\" role=\"tab\" aria-controls=\"navTab<%= index %>\" aria-selected=\"true\"><%= navTabLabel %></a>\n  <% index = index + 1 %>\n  <% }); %>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/cigna_csg_gsg_elasticsearch/src/js/views/nav-tabs.tpl.html
// module id = zJ5f
// module chunks = 4